import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import Feed from 'react-jsonschema-form';
import { Button } from 'react-bootstrap';
import { getFeedSchema, uiSchema, validate } from './Schema';

export default function NewFeedPack({ fetching, feedMappings, onCreate }) {
  const onSubmit = ({ formData }) => onCreate(formData);
  const feedTypes = feedMappings.map(mapping => mapping.type);
  const [newFeed, setFeed] = useState({
    feedType: 'csv',
    config: { feedType: 'csv' },
  });
  const schema = useMemo(() => getFeedSchema(newFeed.feedType, feedTypes), [
    newFeed.feedType,
    feedTypes,
  ]);
  return (
    <div className="feed-list-container">
      <Feed
        schema={schema}
        onChange={a => {
          const feedType = a.formData.feedType;
          const hasFeedTypeChange = feedType !== newFeed.feedType;
          setFeed({
            ...a.formData,
            config: hasFeedTypeChange ? { feedType } : a.formData.config,
          });
        }}
        uiSchema={uiSchema}
        formData={newFeed}
        validate={validate}
        onSubmit={onSubmit}
      >
        <Button
          bsClass="btn btn-primary btn-large"
          disabled={fetching}
          type="submit"
        >
          Submit
        </Button>
      </Feed>
    </div>
  );
}

NewFeedPack.propTypes = {
  fetching: PropTypes.bool,
  feedMappings: PropTypes.array,
  onCreate: PropTypes.func,
};
